const NAMESPACE = "TIN_TERMINAL";
const actionType = type => `${NAMESPACE}_${type}`;

export const terminalConstants = {
	SET_CREATE_STAGE_ONLY_VAR_IN_PROGRESS: actionType(
		"SET_CREATE_STAGE_ONLY_VAR_IN_PROGRESS",
	),
};
